export default __webpack_public_path__ + "static/media/CNo.92-3.ec69abd7.jpg";